export default "__VITE_ASSET__BY6C7Qlu__"